import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback
} from "react";
import Footer from "../../Footer";
import useDynamicPageSize from "../../useDynamicPageSize";
import Table from "../../core/common/dataTable/index";
import nodeApi from "../../nodeApi";
import { useFilterData } from "../../context/FilterContext";
import api from "../../api";
import moment from "moment";
import LeaveModal from '../leave/LeaveModal';
import { toast,ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";

interface Notification {
  id: number;
  message: string;
  createdAt: string;
  isRead: boolean;
  leaveId: number;
  interviewId: number;
  userId: number;
  type: string,
  meetingLink?: string;
}

const AllNotifications: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [tableHeight, setTableHeight] = useState<number>(0);
    const pageSize = useDynamicPageSize();
    const [pageSizeReady, setPageSizeReady] = useState(false);
    const navigate = useNavigate();
    // Set pageSizeReady true only once — when value stabilizes
useEffect(() => {
  const timeout = setTimeout(() => {
    setPageSizeReady(true);
  }, 100); // Wait until layout stabilizes (tweak delay if needed)

  return () => clearTimeout(timeout);
}, [pageSize]);

    const [totalItems, setTotalItems] = useState(0);
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [loading, setLoading] = useState(true);
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = userData?.id;
    const { filtersData } = useFilterData();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedNotificationId, setSelectedNotificationId] = useState<number | null>(null);
    const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
    interface Employee {
        id: number;
        name: string;
        [key: string]: any;
    }
    const [employeesForm, setEmployeesForm] = useState<Employee[]>([]);
    type ValidationErrors = {
        selectedType?: string;
        noOfLeave?: string;
        notes?: string;
    };
    const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
            {}
          );
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const initialRole = storedUser?.role_name ?? null;
    const [userRole, setUserRole] = useState<number | null>(initialRole);

    useEffect(() => {
            const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
            const loggedInUserId = String(storedUser?.id);
            setLoggedInUserId(loggedInUserId);
    }, []); // run once on mount
    
    useEffect(() => {
              if (filtersData && Object.keys(filtersData).length > 0) {
                  setEmployeesForm(filtersData?.names);
              }
    }, [filtersData]);

  useLayoutEffect(() => {
      //  if (pageSize === 0) return;
      const calculateHeight = () => {
        const baseOffset = 194;
        const extraOffset = window.innerWidth <= 991 ? -75 : -81;
        const fixedOffset = baseOffset + extraOffset;
  
        const newHeight = window.innerHeight - fixedOffset;
  
        console.log("Calculated table height:", newHeight);
        console.log("fixedOffset:", fixedOffset);
        console.log("window.innerHeight:", window.innerHeight);
        console.log("totalItems :", totalItems);
        console.log("pagesize :", pageSize);
        setTableHeight(newHeight);
      };
  
      calculateHeight(); // initial + on totalItems change
      window.addEventListener("resize", calculateHeight);
  
      return () => window.removeEventListener("resize", calculateHeight);
    }, [totalItems, pageSize]);

    const handleConfirm = (id: number) => {
    setSelectedNotificationId(id);
    setShowConfirmModal(true);
    };

  const fetchAllNotifications = useCallback(async () => {
    if (!pageSizeReady) return;
    setLoading(true);
    try {
      const response = await nodeApi<{
        notifications: Notification[];
        totalRecords: number;
        currentPage: number;
        lastPage: number;
      }>(`/all/${userId}`, {
        method: "POST",
        body: { currentPage, pageSize },
      });

      setNotifications(response.notifications);
      setTotalItems(response.totalRecords);
    } catch (err) {
      console.error("Failed to fetch notifications", err);
    } finally {
      setLoading(false);
    }
  }, [userId, currentPage, pageSize, pageSizeReady]);

  useEffect(() => {
    fetchAllNotifications();
  }, [fetchAllNotifications]);

  const markAsRead = async (notificationId: number) => {
    setLoading(true);
    try {
      await nodeApi<any>(`/mark-as-read/${notificationId}`, {
        method: "PATCH",
      });
      fetchAllNotifications();
    } catch (err) {
      console.error("Failed to mark as read", err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
  {
  title: "Message",
  dataIndex: "message",
  key: "message",
  width: "60%",
  render: (_: any, record: Notification) => {
    const shouldTruncate = ["birthday_personal","birthday_announcement", "work_anniversary_personal","work_anniversary_announcement", "holiday"].includes(record.type);

    return (
      <div className="d-flex align-items-center justify-content-between">
        <span
          title={shouldTruncate ? record.message : ""}
          style={
            shouldTruncate
              ? {
                  maxWidth: "420px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                }
              : {}
          }
        >
          {record.message}
        </span>

        {(record.type === "interview" && record.meetingLink) && (
          <a
            href={record.meetingLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary ms-2"
            onClick={(e) => e.stopPropagation()} // prevent row click
          >
            Join Meeting
          </a>
        )}
      </div>
      );
    },
  },
  {
    title: "Date Time",
    dataIndex: "createdAt",
    key: "createdAt",
    width: "25%",
    render: (date: string) => {
        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, "0");
        const month = d.toLocaleString("en-IN", { month: "short", timeZone: "Asia/Kolkata" }).toUpperCase();
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const seconds = String(d.getSeconds()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        const hh = String(hours).padStart(2, "0");

        return `${day}-${month}-${year}, ${hh}:${minutes}:${seconds} ${ampm}`;
        }
  },
  {
    title: "Action",
    dataIndex: "actions",
    key: "actions",
    width: "15%",
    render: (_: any, record: Notification) => (
      <div style={{ minHeight: "38px", display: "flex", alignItems: "center" }}>
        {!record.isRead ? (
          <button
            type="button"
            className="btn-mark btn-primary"
            onClick={(e) => {
                e.stopPropagation(); 
                handleConfirm(record.id);
            }}
          >
            Mark as Read
          </button>
        ) : (
          // Empty space to maintain height
          <div style={{ height: 38 }} />
        )}
      </div>
    ),
  },
];

interface LeaveDetails {
    showModal1: boolean;
    isEditMode: boolean;
    editId?: number;
    leaveType: number | undefined;
    leaveDuration: string;
    singleDate: string;
    startDate: string;
    endDate: string;
    halfShortDate: string;
    halfDayType: string;
    reason: string;
    status: string;
    disableAllFields: boolean;
    disableAllExceptStatus: boolean;
    userId?: number;
    leaveAppliedDate: string;
    users: Employee[];
    selectedEmployeeId: number | undefined;
    validationErrors?: any;
    currentPage?: number;
    pageSize?: number;
  }

  const [leaveDetails, setLeaveDetails] = useState<LeaveDetails>({
      showModal1: false,
      isEditMode: false,
      leaveType: undefined,
      leaveDuration: "",
      singleDate: "",
      startDate: "",
      endDate: "",
      halfShortDate: "",
      halfDayType: "",
      reason: "",
      status: "",
      disableAllFields: false,
      disableAllExceptStatus: false,
      leaveAppliedDate: "",
      selectedEmployeeId: parseInt(loggedInUserId || "0"),
      users: employeesForm,
    });

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        console.log("closemodal called:", isModalOpen);
        setLeaveDetails({} as LeaveDetails);
      }, []);

  interface LeaveEditResponse {
    duration: string;
    half: number;
    from_date: string;
    to_date?: string;
    reason?: string;
    leave_type?: number;
    status: number;
    user_id: number;
    created_at: string;
  }

  const isDateInPast = (date: string) => {
      return moment(date).isBefore(moment(), "day");
    };
  
  const formatDate = (date: string) =>
      date ? moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY") : "";
  const formatLeaveAppliedDate = (date: string) =>
      date ? moment(date).format("DD-MMM-YYYY hh:mm A") : "";

  const isDateToday = (dateStr: string) => {
    const inputDate = new Date(dateStr);
    const today = new Date();
    return (
      inputDate.getFullYear() === today.getFullYear() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getDate() === today.getDate()
    );
  };

  const handleEdit = async (id: number) => {
      setIsModalOpen(true)
    
      try {
        const response = await api<LeaveEditResponse>(`/edit-leave-request/${id}`, {
          method: "GET",
        });
        
        const data = response; 
        console.log("leave",data)   
    
        let leaveDuration = "";
        if (data.duration === "1") leaveDuration = "single";
        else if (data.duration === "0.5") leaveDuration = "half";
        else if (data.duration === "0.25") leaveDuration = "short";
        else if (parseInt(data.duration) > 1) leaveDuration = "multi";
    
        let half = "";
        if (data.half === 1) half = "first-half";
        else if (data.half === 2) half = "second-half";
    
        const isSingleDatePast = isDateInPast(data.from_date);
        const isEndDatePast = data.to_date ? isDateInPast(data.to_date) : false;
    
        const disableAllExceptStatus = userRole === 2 && data.status === 2;
  
        const localDisableAllFields =
          disableAllExceptStatus
            ? true
            : [3, 5].includes(data.status) ||
              (data.status === 4 &&
                isSingleDatePast &&
                (!data.to_date || isEndDatePast) &&
                (userRole === 1 || userRole === undefined)) ||
              ((data.status === 4 || data.status === 2) &&
                userRole === 2 &&
                (!data.to_date || isEndDatePast));
    
          console.log("selectedUserId leave:", data.user_id );
    
        setLeaveDetails({
          showModal1: true,
          isEditMode: true,
          editId: id,
          leaveType: data.leave_type || undefined,
          leaveDuration,
          singleDate: formatDate(data.from_date),
          startDate: formatDate(data.from_date),
          endDate: formatDate(data.to_date ?? ""),
          halfShortDate: formatDate(data.from_date),
          halfDayType: half,
          reason: data.reason || "",
          status: String(data.status) || "",
          disableAllFields: localDisableAllFields,
          disableAllExceptStatus,
          userId: data.user_id || 0,
          leaveAppliedDate: formatLeaveAppliedDate(data.created_at),
          users:employeesForm,
          selectedEmployeeId:data.user_id ?? 0,
          validationErrors,
        });
      } catch (error) {
        console.error("Error fetching leave request:", error);
      }
    };

  const SimpleConfirmModal = ({ isOpen, onClose, onConfirm }: any) => {
    if (!isOpen) return null;
    return (
      <>
        {/* Dimmed Background Overlay */}
        <div
          className="modal-backdrop fade show"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1040,
          }}
        ></div>

        <div
          className="modal fade show"
          style={{ display: "block", zIndex: 1050 }}
          aria-labelledby="confirmModalLabel"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="confirmModalLabel">
                  Confirm
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                Are you sure you want to mark this notification as read?
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cancel"
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onConfirm}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="page-wrapper d-flex flex-column notifs">
        <div className="content flex-grow-1">
          <div className="card card-margin-bottom">
            <div
              className="card-body p-0"
              id="Designation-list"
              style={{
                height: tableHeight,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Table
                style={{ flex: 1 }}
                currentPage={currentPage}
                dataSource={notifications}
                columns={columns}
                onPageChange={setCurrentPage}
                totalItems={totalItems}
                pageSize={pageSize}
                loading={loading}
                onRowClick={(record) => {
                  if (!record.isRead) {
                      markAsRead(record.id);
                  }

                  switch (record.type) {
                      case "interview":
                          navigate(`/interviews?interviewId=${record.interviewId}`);
                          break;

                      case "leave":
                          handleEdit(record.leaveId);
                          break;

                      case "birthday":
                      case "birthday_personal":
                      case "birthday_announcement":
                      case "work_anniversary_personal":
                      case "work_anniversary_announcement":
                      case "holiday":
                        // No modal / no navigation
                        break;

                      default:
                          break;
                  }
                }}

              />
            </div>
          </div>
        </div>
        <Footer />
      </div>

        <SimpleConfirmModal
            isOpen={showConfirmModal}
            onClose={() => setShowConfirmModal(false)}
            onConfirm={() => {
                if (selectedNotificationId !== null) {
                markAsRead(selectedNotificationId);
                setShowConfirmModal(false);
                }
            }}
        />

      <LeaveModal
              leaveDetails={leaveDetails}
              isOpen={isModalOpen}
              onClose={closeModal}
              userRole={userRole ?? 0}
        >
              <></>
        </LeaveModal>
        <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default AllNotifications;
